import React from 'react'
import { useSelector } from 'react-redux'
import { getTimeByTimezone } from 'app/utils/date'
import Text from '../components/Text'
import Emoji from '../components/Emoji'
import Voice from '../components/Voice'
import ImageMessage from '../components/Image'
import FileMessage from '../components/File'
import MessageStatus from '../components/MessageStatus'
import VideoMessage from '../components/Video'
import Reply from '../components/Reply'
import ReplyPreview from '../components/ReplyPreview'
import Time from '../components/Time'
import InnerMsgWrapper from '../components/InnerMsgWrapper'
import './userMessage.scss'

const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

const MESSAGE_TYPE_KEY = 'user'

const UserMessage = ({
  createdAt,
  messageType,
  messageId,
  messageContent,
  messageStatus,
  messageReplyId,
  botId,
  fileUrl,
  name,
  size,
  fileData,
}) => {
  const showReplyIcon = messageStatus !== 'pending' && !botId

  const languageInfo = useSelector(getLanguageInfo)
  const language = languageInfo.general.language

  const timezone = language === 'en' ? 'en-GB' : 'fa-IR'
  const messageTime = createdAt && getTimeByTimezone(createdAt, timezone)
  const renderRepliedMsgPreview = messageReplyId && (
    <ReplyPreview msgRepliedOnId={messageReplyId} languageInfo={languageInfo} />
  )

  //TODO: better to have wrapper for replied message preview
  const getProperMessage = () => {
    switch (messageType) {
      case 'text':
        return (
          <Text
            type={MESSAGE_TYPE_KEY}
            title={messageTime}
            textContent={messageContent}
            renderRepliedMsgPreview={renderRepliedMsgPreview}
          />
        )

      case 'emoji':
        return (
          <Emoji
            type={MESSAGE_TYPE_KEY}
            title={messageTime}
            content={messageContent}
            renderRepliedMsgPreview={renderRepliedMsgPreview}
          />
        )

      case 'audio':
        return <Voice type={MESSAGE_TYPE_KEY} renderRepliedMsgPreview={renderRepliedMsgPreview} url={fileUrl} />

      case 'image':
        return (
          <ImageMessage
            type={MESSAGE_TYPE_KEY}
            renderRepliedMsgPreview={renderRepliedMsgPreview}
            title={messageTime}
            url={fileUrl}
          />
        )

      case 'compress':
      case 'file':
        return (
          <FileMessage
            type={MESSAGE_TYPE_KEY}
            title={messageTime}
            renderRepliedMsgPreview={renderRepliedMsgPreview}
            fileName={name}
            fileSize={size}
            url={fileUrl}
          />
        )

      case 'video':
        // Question: which one?
        return <VideoMessage url={fileData || fileUrl} />

      default:
        break
    }
  }

  return (
    <div data-id={messageId} className="user_text_message_container">
      <InnerMsgWrapper type={MESSAGE_TYPE_KEY}>
        <div>{getProperMessage()}</div>

        <div className="user_message_status_cotainer">
          <div className="user_message_status">
            <MessageStatus status={messageStatus} />
            <Time text={messageTime} />
          </div>
          {showReplyIcon && (
            <Reply
              type={MESSAGE_TYPE_KEY}
              messageType={messageType}
              messageId={messageId}
              messageContent={messageContent}
              languageInfo={languageInfo}
            />
          )}
        </div>
      </InnerMsgWrapper>
    </div>
  )
}

export default React.memo(UserMessage)
